import { useContext } from 'react';

import type { AppContextOptions } from './context';
import AppContext from './context';

type UseAppContext = () => AppContextOptions;
export const useAppContext: UseAppContext = () => useContext(AppContext);

export const useIsCurrentNetworkInMto = (): boolean => useAppContext().isCurrentNetworkInMto;
